import React from 'react';
import PropTypes from 'prop-types';

import './HeroContainer.scss';

const HeroContainer = ({ children }) => {
  return <div className="hero">{children}</div>;
};

HeroContainer.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export default HeroContainer;
